import translations from './translations'

translations.add('en', {
    description: 'Something went wrong! Please check the data or try again later.',
    close: 'CLOSE'
})
